import TextMessage from './TextMessage';
import ButtonsMessage from './ButtonsMessage';
import ListMessage from './ListMessage';
import TemplateMessage from './TemplateMessage';
import MediaMessage from './MediaMessage';
import DocumentMessage from './DocumentMessage';
import ReplyMessage from './ReplyMessage';
import CardMessage from './CardMessage';
import FallbackMessage from './FallbackMessage';

export const MESSAGE_RENDERERS = {
  text: TextMessage,
  buttons: ButtonsMessage,
  list: ListMessage,
  template: TemplateMessage,
  image: MediaMessage,
  video: MediaMessage,
  audio: MediaMessage,
  document: DocumentMessage,
  reply: ReplyMessage,
  order: CardMessage,
  catalog: CardMessage,
  location: CardMessage,
  payment: CardMessage,
  flow: CardMessage,
  nfm_reply: CardMessage,
  ctaurl: CardMessage,
  openai: CardMessage,
  intervention: CardMessage,
  orderstatus: CardMessage,
  address: CardMessage,
};

export default function MessageBody({ message }) {
  const Renderer = MESSAGE_RENDERERS[message.kind] || FallbackMessage;
  return <Renderer message={message} />;
}
